import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import ListItem from '../../shared/styledComponents/ListItem';

export default InjectedStyledComponent(ListItem, 'disclaimer', ['listItem']);